import React, { useState, useEffect } from 'react';
import { currentUser } from '../../services/CurrentUser';
import Constants from '../../Constants';
import PubSub from 'pubsub-js';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';

function EirCart(props) {
    const [cart, setCart] = useState(null);
    const graphql = useApolloClient();

    const getCart = async () => {
        PubSub.subscribe(Constants.eventKeys.cartSubscriberAdded, publishCart);
        if (currentUser.getAttribute(Constants.cacheKeys.orderId)) {
            let response = await fetch('/store/api/cart');
            let cart = await response.json();
            setCart(cart);
            publishCart();
        }
        if (localStorage.getItem('prospectUuid')) {
            ionCartDetails();
        }
        // changes for getting quadplay cart
        if(localStorage.getItem('ACQ_PROSPECTUUID') || localStorage.getItem('CO_REF') || localStorage.getItem('CS_REF')) {
            if(localStorage.getItem('ACQ_HANDSET_BE_OFFERID') === null || localStorage.getItem('ACQ_HANDSET_BE_OFFERID') === '')
                {
                    quadplayCartDetails();
                }
        }
    };
    const publishCart = (msg, data) => {
        if (data) {
            if(data.numberOfProducts!=0)
                setCart(data);
            else
                setCart(null);
        }
        if (cart) {
                PubSub.publish(Constants.eventKeys.cartContentChanged, cart);
        }
    };
    const quadplayCartDetails = async () => {
        try {
            let reference = '';
            let cartType = '';
            if(localStorage.getItem('ACQ_PROSPECTUUID')) {
                reference = localStorage.getItem('ACQ_PROSPECTUUID');
                cartType = 'NEW_ACQUISITION';
            }
            else if(localStorage.getItem('CO_REF')){
                reference = localStorage.getItem('CO_REF');
                cartType = 'CHANGE_OFFER';
            }
            else if(localStorage.getItem('CS_REF')){
                reference = localStorage.getItem('CS_REF');
                cartType = 'CROSS_SELL';
            }
            const res = await graphql.query({
                query: ENDPOINT.GET_QUADPLAY_CART_DETAILS,
                variables: { reference: reference, cartType: cartType },
            });
            if (res.data.getCart) {
                setCart(res.data.getCart);
                
                publishCart('', {numberOfProducts: res.data.getCart.offers.length});
            }
        } catch (err) {
            console.log('ERROR>>>>', err.message);
        }
    }
    const ionCartDetails = async () => {
        try {
            let prospectUuid = localStorage.getItem('prospectUuid');
            const res = await graphql.query({
                query: ENDPOINT.GET_CART_DETAILS,
                variables: { prospectUuid: localStorage.getItem('prospectUuid') },
            });
            if (res.data.cartDetails) {
                setCart(res.data.cartDetails);
                publishCart();
            }
        } catch (err) {
            console.log('ERROR>>>>', err.message);
        }
    };
    useEffect(() => {
        getCart();
    }, []);
    return (
        <div className='position-relative mt-md-1 mt-lg-3 d-flex'>
            {/* EIRZWM-280 */}
            {/* <div className="eir-icon icon-cart--black icon-cart text-right" />
            <div className="d-none d-lg-inline">Cart</div> */}

            <div className='d-none d-lg-inline meganav-cart-label'>My cart</div>
            <div className='eir-icon meganav-icon-cart icon-cart text-right' />
            {cart && <div className='cart-quantity'>{cart.numberOfProducts}</div>}
        </div>
    );
}
export default EirCart;
